/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function GroupsModalController(
    this: JS5Object,
    uiGridConstants: JS5Object
) {

    const columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];
    this.searchText = '';
    this.selectedRows = [];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
    this.executeSearch = (): void => {
        this.gridApi.grid.refresh();
    };
    this.processGridFilter = (renderableRows) => {
        renderableRows.forEach((row) => {
            if (_.includes(_.toLower(row.entity.name), _.toLower(this.searchText))) {
                row.visible = true;
            } else {
                row.visible = false;
            }
        });
        return renderableRows;
    };

    this.disableOKButton = () => {
        return this.gridApi.selection.getSelectedRows().length === 0;
    };


    this.$onInit = () => {
        this.gridOptions.data = this.resolve.availableGroups;
    };

}

angular.module('prism-ui.package').component('groupsModal', {
    templateUrl: 'package/editor/components/modals/groups/groups-modal-template.html',
    controller: GroupsModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});
